import api from './api';

export type NoteEntityType = 'patient' | 'internal_task';

export interface Note {
  id: number;
  entity_type: NoteEntityType;
  entity_id: number;
  text: string;
  created_by: number | null;
  created_by_name: string | null;
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export const noteService = {
  async getNotes(entityType: NoteEntityType, entityId: number): Promise<Note[]> {
    const response = await api.get('/notes/', { params: { entity_type: entityType, entity_id: entityId } });
    return response.data;
  },

  async createNote(data: { entity_type: NoteEntityType; entity_id: number; text: string }): Promise<Note> {
    const response = await api.post('/notes/', data);
    return response.data;
  },

  async updateNote(id: number, data: { text: string }): Promise<Note> {
    const response = await api.put(`/notes/${id}`, data);
    return response.data;
  },
};

export default noteService;
